import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const FirstLaborPolicy = (params) => {
  return (
    <UserInterface>
      <div class="row mx-0">
        <div className="container d-flex flex-wrap">
          <div class="col-md-6 py-4 pe-2 row mx-0">
            <div class="shadowclass">
              <h4 class="event-alert">
                Create and manage the policy settings that will help you formalize
                HR standards and employee benefits.{" "}
              </h4>
              <img src="/img/step1-1.png" class="img-responsive" />
            </div>
          </div>

          <div class="col-md-6 py-4 ps-2 row mx-0">
            <div class="shadowclass">
              <h4 class="event-alert">
                Any policies setup in the system will reduce the time taken to
                setup individual employee profiles and help ensure accuracy and
                consistency across the team.{" "}
              </h4>

              <img src="/img/step1-2.png" class="img-responsive" />
            </div>
          </div>


          <div className="row mx-0 w-100">
            <div class="btns d-flex justify-content-end py-4 col-12 px-0">
                <button type="Submit"> Next </button>
            </div>
          </div>
        </div>
      </div>

    </UserInterface>
  );
};
export default FirstLaborPolicy;
